module.exports = __webpack_public_path__ + "static/media/zone4-stairs.d0656c02.png";